import MENU_ITEMS from './menu-items';
import RAILWAY_CARRIAGE_ITEMS from './railway-carriage-items';
import {SWIPER_ITEMS_P3, SWIPER_ITEMS_P5} from './swiper-items';
import PUBLIC_PATHS from './url-paths';

const PATHS = {
	PUBLIC: PUBLIC_PATHS,
};

export {MENU_ITEMS, PATHS, RAILWAY_CARRIAGE_ITEMS, SWIPER_ITEMS_P3, SWIPER_ITEMS_P5};
